<template>
  <div>
    <template v-if="loaded">
      <!-- <a-alert :message="$t('system.text_181')" type="success" class="mb-2" /> -->
      <vxe-table
        resizable
        highlight-hover-row
        ref="table"
        show-overflow="title"
        :data="tableData"
        :edit-config="{trigger: 'manual', mode: 'row'}">
        <vxe-table-column field="label" :title="$t('system.text_101')" :width="200" />
        <vxe-table-column field="value" :title="$t('system.text_102')" :width="160" :formatter="valueFormatter" />
        <vxe-table-column field="desc" :title="$t('system.text_182')" :min-width="300" />
        <vxe-table-column :title="$t('system.text_55')" :width="160">
          <template v-slot="{ row }">
            <a-button type="link" @click="editRowEvent(row)">{{$t('system.text_183')}}</a-button>
          </template>
        </vxe-table-column>
      </vxe-table>
    </template>
    <template v-else>
      <div class="text-center pt-4 pb-4">
        <a-spin />
      </div>
    </template>
  </div>
</template>

<script>
import * as R from 'ramda'
import WindowsMixin from '@/mixins/windows'
import { getRequestT } from '@/utils/utils'
import { GLOBAL_SETTING_OPTIONS, GLOBAL_SETTING_OPTIONS_SORT } from '../constants'

export default {
  name: 'GlobalSettingsList',
  mixins: [WindowsMixin],
  props: {
    cloudEnv: String,
  },
  data () {
    return {
      data: [],
      identityId: '',
      commonId: '',
      yunionapiId: '',
      notifyId: '',
      computeId: '',
      imageId: '',
      baremetalId: '',
      meterId: '',
      logId: '',
      cloudmonId: '',
      webconsoleId: '',
      keystoneId: '',
      loaded: false,
    }
  },
  computed: {
    enable_syslog_webservice () {
      const list = this.data.filter(item => item.key === 'enable_syslog_webservice')
      return list.length && list[0].value === 'true'
    },
    tableData () {
      const filterData = R.sort((a, b) => a.index - b.index, this.data)
      return filterData.filter(item => {
        if (['syslog_webservice_username', 'syslog_webservice_password'].includes(item.key) && !this.enable_syslog_webservice) {
          return false
        }
        return item.opt.belong === this.cloudEnv
      })
    },
  },
  async created () {
    this.manager = new this.$Manager('services', 'v3')
    this.fetchServices()
  },
  methods: {
    async fetchServices () {
      try {
        const allFetcher = []
        const serviceIds = ['region2', 'glance', 'common', 'yunionapi', 'notify', 'baremetal', 'websocket', 'meter', 'log', 'cloudmon', 'webconsole', 'keystone', 'monitor']
        serviceIds.forEach(id => {
          let key = id
          if (id === 'region2') {
            key = 'compute'
          }
          if (id === 'glance') {
            key = 'image'
          }
          if (id === 'keystone') {
            key = 'identity'
          }
          this[`${key}Id`] = key
          // 为每个请求添加错误处理，确保单个请求失败不影响其他请求
          const fetchPromise = this.fetchConfig(id, key, GLOBAL_SETTING_OPTIONS[key.toUpperCase()]).catch(error => {
            // 单个请求失败时记录错误，但不抛出，让其他请求继续执行
            console.error(`Failed to fetch config for ${id}:`, error)
            return null // 返回 null 表示该请求失败
          })
          allFetcher.push(fetchPromise)
        })
        // 使用 Promise.allSettled 替代 Promise.all，确保所有请求都能完成（无论成功或失败）
        Promise.allSettled(allFetcher).then(results => {
          // 检查是否有请求失败
          const failedCount = results.filter(r => r.status === 'rejected').length
          if (failedCount > 0) {
            console.warn(`${failedCount} service config request(s) failed, but continuing with successful ones`)
          }
        }).finally(() => {
          this.loaded = true
          this.$nextTick(() => {
            const list = []
            this.data.forEach(item => {
              if (!list.includes(item.opt.belong)) {
                list.push(item.opt.belong)
              }
            })
            this.$emit('result', list)
          })
        })
      } catch (error) {
        // 即使有错误，也设置 loaded 为 true，以便显示已成功加载的数据
        this.loaded = true
        console.error('Error in fetchServices:', error)
      }
    },
    fetchConfig (id, service, options) {
      return new Promise((resolve, reject) => {
        this.manager.getSpecific({
          id,
          spec: 'config',
          params: {
            $t: getRequestT(),
          },
        }).then(response => {
          const config = (response.data.config && response.data.config.default) || {}
          R.forEachObjIndexed((opt, key) => {
            this.data.push({
              opt,
              label: this.$te(`globalSetting.${service}$${key}.label`) ? this.$t(`globalSetting.${service}$${key}.label`) : key,
              desc: this.$te(`globalSetting.${service}$${key}.desc`) ? this.$t(`globalSetting.${service}$${key}.desc`) : '-',
              dialogLabel: this.$te(`globalSetting.${service}$${key}.dialog_label`) ? this.$t(`globalSetting.${service}$${key}.dialog_label`) : '',
              dialogDesc: this.$te(`globalSetting.${service}$${key}.dialog_desc`) ? this.$t(`globalSetting.${service}$${key}.dialog_desc`) : '',
              serviceId: id,
              key,
              service,
              value: this.getValue(config[key], opt, config), // 这里传递 config 是为了处理全局代理，给formatter里面传递config的值，使之根据global_http_proxy和global_https_proxy的有无判断是否开启了全局代理
              index: GLOBAL_SETTING_OPTIONS_SORT.indexOf(`${service}$${key}`),
              config, // 这里传递 config 是为了处理全局代理，给dialog里面传递config的值，使之初始化的值能够返显
            })
          }, options)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    editRowEvent (row) {
      const dialog = row.opt.dialog || 'GlobalSettingUpdateDialog'
      this.createDialog(dialog, {
        data: [row],
        success: this.refresh,
        ok: row.opt.ok,
        config: row.config,
        skipUpdate: row.opt.skipUpdate,
      })
    },
    getValue (val, opt, config) {
      if (!R.isNil(val)) {
        if (opt.formatter) {
          return opt.formatter(val, opt, config)
        }
        return val
      }
      if (R.is(Function, opt.defaultValue)) {
        return opt.defaultValue()
      }
      return opt.defaultValue || ''
    },
    refresh (key, value, serviceId, extraObj = {}) {
      let index
      for (let i = 0, len = this.data.length; i < len; i++) {
        const item = this.data[i]
        if (item.key === key && item.serviceId === serviceId) {
          index = i
        }
      }
      const newValue = { ...this.data[index], ...extraObj }
      newValue.value = value
      let data = [...this.data]
      data = R.remove(index, 1, data)
      data.push(newValue)
      this.data = data
    },
    valueFormatter (row) {
      if (row.row.opt.tableFormatter) {
        return row.row.opt.tableFormatter(row)
      }
      return row.cellValue
    },
  },
}
</script>
